module.exports = __webpack_public_path__ + "img/home-analytics-1.6ab01dbf.svg";